import React, { useEffect, useState } from 'react';
import { Dimensions, View, TextInput } from "react-native";
import Modal from 'modal-enhanced-react-native-web';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';

const { width } = Dimensions.get('screen');

type CompetitionCodeEnterModalProps = { isVisible:boolean, closeModal:any, onEnter: (code:string) => void}
function CompetitionCodeModal({ isVisible, closeModal, onEnter}:CompetitionCodeEnterModalProps) {
    const [ competition_code, setCompetitionCode ] = useState('')

   
    return (
        <Modal propagateSwipe={true} isVisible={isVisible} deviceWidth={width>800?800:width} style={{ flex:1, margin: 0, alignItems:'center',  justifyContent: 'flex-end' }}
        animationIn='slideInUp' animationOut='slideOutDown' animationOutTiming={400} 
        swipeDirection={['down']} onSwipeComplete={() => closeModal()}
        onBackdropPress={() => closeModal()} >
            <View style={styles.modalStyle}>
                <View style={{padding:5}}>
                    <Text size={16} color={Colors.brand.midnight} weight='bold' textAlign='center'>Enter Competition Code</Text>
                </View>
                <View style={{padding:20}}>
                    <TextInput style={{ fontFamily:'barlow-regular', color:Colors.brand.electric, padding:10, borderWidth:1, borderRadius:4, borderColor:Colors.highlights.highlight200 }} placeholder='Enter Code ...' value={competition_code} onChangeText={(e) => setCompetitionCode(e)}/>
                </View>
                <View style={{padding:10, paddingLeft:15, paddingRight:15, flexDirection:'row', alignItems:'center'}}>
                    <TouchableOpacity style={{flex:1/3, padding:10, borderRadius:4, marginRight:4, borderWidth:1, borderColor:Colors.brand.midnight}} onPress={() => closeModal()}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>Cancel</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={{padding:10, borderRadius:4, flex:2/3, marginLeft:4, borderWidth:1, backgroundColor:Colors.utility.success}} onPress={() => onEnter(competition_code.toLowerCase())}>
                        <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>Search</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>
    )
    }

const styles = {
    modalStyle: { width:width>800?800:width, backgroundColor: Colors.shades.white, borderTopRightRadius: 42, borderTopLeftRadius: 42, paddingBottom:35, paddingTop:30 },
}


export default CompetitionCodeModal